import React from 'react'

import { bemJoin } from 'bem-join'

import { FormattedDate, useIntl } from '@app/intl/Intl'
import './AppointmentsTable.scss'

type AppointmentForTable = {
  lawyer: {
    firstName?: string
    lastName?: string
  }
  appointmentAt: Date
  id: number
}

type Props = {
  appointments: AppointmentForTable[]
}
const b = bemJoin('appointments-table')

export const AppointmentsTable = ({ appointments }: Props) => {
  const { formatMessage } = useIntl()

  if (!appointments.length) {
    return null
  }

  return (
    <div className={b('container')}>
      <h2 className={b('title')}>{formatMessage({ id: 'PrintView.AppointmentsTable.Title' })}</h2>
      <table className={b('table')}>
        <thead>
          <tr>
            <th className={b('header')}>
              {formatMessage({ id: 'PrintView.AppointmentsTable.Date' })}
            </th>
            <th className={b('header')}>
              {formatMessage({ id: 'PrintView.AppointmentsTable.ConsultingLawyer' })}
            </th>
          </tr>
        </thead>
        <tbody>
          {appointments.map((appointment) => {
            return (
              <tr key={appointment.id}>
                <td className={b('cell')}>
                  <FormattedDate value={appointment.appointmentAt} />
                </td>
                <td className={b('cell')}>
                  {appointment.lawyer.firstName} {appointment.lawyer.lastName}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
